<ion-app>
  <ion-split-pane contentId="main-content">
    <ion-menu
      (ionDidOpen)="menuOpened()"
      menuId="main-menu"
      contentId="main-content"
      class="ion-no-padding"
      autoHide="true"
      [swipeGesture]="false"
      *ngIf="isLoggedIn$ | async"
    >
      <ion-content class="ion-no-padding">
        <mat-toolbar>
          <div class="userinitialbg" *ngIf="profileName">
            {{ profileName.charAt(0) }}
          </div>

          <div class="userdisplay">
            <div class="welcomeuser" *ngIf="profileName">
              {{ 'SIDE_MENU.TEXT.GREETING' | translate : { profileName: '' } }}
              <br />
              {{ profileName }}
            </div>
          </div>
        </mat-toolbar>

        <div id="container">
          <ion-menu-toggle
            class="menumar"
            routerDirection="root"
            routerLink="/scan"
          >
            <img class="iconsize" src="assets/icons/qr-scan.png" />

            <div class="menutext">
              <div class="menuname">
                {{ 'SIDE_MENU.TEXT.SCAN_TITLE' | translate }}
              </div>

              <div class="menusub">
                {{ 'SIDE_MENU.TEXT.SCAN_SUBTITLE' | translate }}
              </div>
            </div>
          </ion-menu-toggle>

          <mat-divider></mat-divider>

          <ion-menu-toggle class="menumar" (click)="showStoresInMap()">
            <img class="iconsize" src="assets/icon/search.png" />

            <div class="menutext">
              <div class="menuname">
                {{ 'SIDE_MENU.TEXT.HOME_TITLE' | translate }}
              </div>

              <div class="menusub">
                {{ 'SIDE_MENU.TEXT.HOME_SUBTITLE' | translate }}
              </div>
            </div>
          </ion-menu-toggle>

          <mat-divider></mat-divider>

          <ion-menu-toggle
            class="menumar"
            routerDirection="root"
            routerLink="/wallet"
          >
            <img class="iconsize" src="assets/icon/topup.png" />

            <div class="menutext">
              <div class="menuname">
                {{ 'SIDE_MENU.TEXT.WALLET_TITLE' | translate }}
              </div>

              <div class="menusub">
                {{ 'SIDE_MENU.TEXT.WALLET_SUBTITLE' | translate }}
              </div>
            </div>
          </ion-menu-toggle>

          <mat-divider></mat-divider>

          <ion-menu-toggle
            class="menumar"
            routerDirection="root"
            routerLink="/redeem"
          >
            <img class="iconsize" src="assets/icon/coupon.png" />

            <div class="menutext">
              <div class="menuname">
                {{ 'SIDE_MENU.TEXT.REDEEM_TITLE' | translate }}
              </div>

              <div class="menusub">
                {{ 'SIDE_MENU.TEXT.REDEEM_SUBTITLE' | translate }}
              </div>
            </div>
          </ion-menu-toggle>

          <mat-divider></mat-divider>

          <ion-menu-toggle class="menumar" (click)="logout()">
            <img class="iconsize" src="assets/icon/logout.png" />

            <div class="menutext">
              <div class="menuname">
                {{ 'SIDE_MENU.TEXT.LOGOUT_TITLE' | translate }}
              </div>

              <div class="menusub">
                {{ 'SIDE_MENU.TEXT.LOGOUT_SUBTITLE' | translate }}
              </div>
            </div>
          </ion-menu-toggle>

          <mat-divider></mat-divider>
        </div>
      </ion-content>

      <ion-footer class="footerinfo">
        <div>
          <ion-menu-toggle class="loglink" (click)="goToAbout()">
            {{ 'SIDE_MENU.LINK.ABOUT' | translate }}
          </ion-menu-toggle>
          |
          <ion-menu-toggle class="loglink" (click)="goToTerms()">
            {{ 'SIDE_MENU.LINK.TERMS' | translate }}
          </ion-menu-toggle>
          |
          <ion-menu-toggle class="loglink" (click)="goToPrivacy()">
            {{ 'SIDE_MENU.LINK.PRIVACY' | translate }}
          </ion-menu-toggle>
        </div>
        <div class="copyright">
          {{ version }}
        </div>
      </ion-footer>
    </ion-menu>

    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>
</ion-app>
